import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';

const EXCLUDED_PERSONA_MAILBOX_TYPES = ['GroupMailbox', 'PrivateDL', 'PublicDL'];

export function doesSubjectPickerSupportPersona(persona: FindRecipientPersonaType): boolean {
    return (
        persona.EmailAddress &&
        persona.EmailAddress.EmailAddress &&
        !EXCLUDED_PERSONA_MAILBOX_TYPES.includes(persona.EmailAddress.MailboxType)
    );
}
